import axiosRequest from 'axios';
import { toast } from "react-toastify";
import React, { Component } from "react";
import { Button, Form, Modal, Table } from 'react-bootstrap';
import { PublicClientApplication } from "@azure/msal-browser";

import axios from '../../../axios';
import apiError from '../../../error';
import Loader from '../../../component/loader/loader';
import { eraseCookie, getCookie, setCookie } from '../../../function';

export default class Azure extends Component {
    constructor(props) {
        super(props);
        this.pca = null;
        this.state = {
            companyClientId: process.env.REACT_APP_ClientID,
            clientId: '',
            groupId: '',
            disabled: true,
            groupEnabled: true,
            Groups: [],
            loading: false,
            checkedGroups: {},
            showModal: false
        };
    }

    componentDidMount = () => {
        this.loadAzure();
    }

    validate = () => {
        if (this.state.groupEnabled && Object.values(this.state.checkedGroups).every(v => !v)) {
            toast.error('Please select at least one group');
            return null;
        }
        return true;
    }

    loadAzure = () => {
        this.setState({ loading: true });
        axios.get('/api/company/getAzureSettings')
            .then(res => {
                if (res.data?.result?.clientId) {
                    this.setState({ clientId: getCookie('clientId') || res.data.result.clientId });
                    eraseCookie('clientId');
                }
                this.setState({ loading: false });
            })
            .catch(err => {
                apiError(err);
                this.setState({ loading: false });
            });
    }

    handleLogin = async (status = 'company') => {
        let clientId = this.state.clientId;
        setCookie('clientId', clientId, 10);
        if(status === 'self'){
            clientId = clientId.trim();
            if (clientId.length === 0) {
                toast.error('Please Enter ClientId');
                return;
            }
        } else {
            clientId = this.state.companyClientId
        }
    
        const msalConfig = {
            auth: {
                clientId: clientId,
                authority: 'https://login.microsoftonline.com/common',
                redirectUri: window.location.origin
            }
        };
    
        const loginRequest = {
            scopes: ["User.Read", "Group.Read.All"]
        };
    
        // Manually clear interaction state for independent popups
        sessionStorage.removeItem("msal.interaction.status");
    
        // Create a new instance of PublicClientApplication
        const pcaInstance = new PublicClientApplication(msalConfig);
    
        try {
            // Start login popup
            const loginResponse = await pcaInstance.loginPopup(loginRequest);
    
            if (loginResponse) {
                const account = pcaInstance.getAccountByHomeId(loginResponse.account.homeAccountId);
    
                try {
                    // Acquire token silently for the logged-in account
                    const msalResponse = await pcaInstance.acquireTokenSilent({
                        ...loginRequest,
                        account
                    });
    
                    if (msalResponse) {
                        this.fetchGroups(msalResponse.accessToken);
                    }
                } catch (tokenError) {
                    console.error("Error while acquiring token:", tokenError);
                    apiError(tokenError);
                }
            }
        } catch (err) {
            console.log("Error during loginPopup:", err);
            if (err.errorCode === "user_cancelled") {
                console.warn("User closed the login popup.");
            } else {
                apiError(err);
            }
        } finally {
            this.setState({ loading: false });
        }
    };
    

    loadGroups = (groupArray) => {
        this.setState({ Groups: groupArray });
        axios.get('/api/company/getAzureSettings')
        .then(res => {
            if (res.data?.result?.clientId) {
                this.setState({ 
                    clientId: res.data.result.clientId
                });
            }
            let oldCheckedGroups = {};
            if (res.data?.result?.groups) {
                res.data.result.groups.forEach(group => {
                    oldCheckedGroups[group.azureGroupId] = true;
                });
            }
            this.setState({ loading: false, showModal: false });
            this.setState({ checkedGroups: oldCheckedGroups });
        })
        .catch(err => {
            apiError(err);
            this.setState({ loading: false, showModal: false });
        });
    }

    fetchGroups = (accessToken, link = 'https://graph.microsoft.com/v1.0/groups?$top=999', data = []) => {
        axiosRequest.get(link, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        })
            .then(res => {
                if (res.data && Array.isArray(res.data.value)) {
                    let groupArray = res.data.value.map(group => ({
                        id: group.id,
                        groupName: group.displayName
                    }));
                    data = data.concat(groupArray);
                    if (res.data["@odata.nextLink"]) {
                        this.fetchGroups(accessToken, res.data["@odata.nextLink"], data);
                    } else {
                        this.loadGroups(data);
                    }
                } else {
                    this.loadGroups(data);
                }
            })
            .catch(err => {
                if (err.message) toast.error('Unable To Fetch Group From Azure');
                this.setState({ loading: false, showModal: false });
            });
    }

    handleAzure = () => {
        let selectedGroups = this.state.Groups.filter(group => this.state.checkedGroups[group.id]);
        axios.post('/api/company/setAzureSettings', {
            azureClientId: this.state.clientId,
            azureGroupEnabled: this.state.groupEnabled,
            groups: selectedGroups
        }).then(res => {
            toast.success(res.data.message);
        })
            .catch(err => {
                apiError(err);
            });
    }

    handleGroupCheckBox = (e, groupId, name) => {
        let newCheckedGroups = { ...this.state.checkedGroups };
        newCheckedGroups[groupId] = e.target.checked;
        this.setState({ checkedGroups: newCheckedGroups });
    };

    enableOrDisbleAzureSetting = (status) => {
        axios.post('/api/company/enableOrDisbleAzureSetting', {
            status
        })
        .then(() => {
            this.setState({ groupEnabled: status });
        })
        .catch(err => {
            apiError(err);
        });
    }
    
    render() {
        return (
            <div className="tab-wrap">
                <div className='tabHeading'>
                    <h6>Azure Settings</h6>
                    <p>Settings and integrations with Microsoft Azure services for cloud computing and storage.</p>
                </div>
                <div className="row m-0">
                    <div className="col-sm-2 select-wrapper" onClick={() => this.handleLogin('company')}>
                        <h6>
                            Fetch via <br></br> Direct Method
                        </h6>
                    </div>
                    <div className="col-sm-2 select-wrapper" onClick={() => this.setState({ showModal: true })}>
                        <h6>
                            Fetch via <br></br> Client ID
                        </h6>
                    </div>
                </div>
                <div className="col-md-6 pl-0 fetched-table">
                        {this.state.Groups?.length > 0 && (
                            <>
                                <Form.Label>Select groups to fetch</Form.Label>
                                <Table bordered hover>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Groups</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.Groups.map(group => (
                                            <tr key={group.id}>
                                                <td>
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={!!this.state.checkedGroups[group.id]}
                                                        onChange={e => this.handleGroupCheckBox(e, group.id, group.groupName)}
                                                    />
                                                </td>
                                                <td>{group.groupName}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                <Button variant="success" type="button" onClick={this.handleAzure}>
                                    Fetch Selected Groups
                                </Button>
                            </>
                        )}
                </div>
            {this.state.loading && <Loader />}

            <Modal show={this.state.showModal} className="chooseModal" onHide={() => this.setState({ showModal: false })} dialogClassName="modal-90w" aria-labelledby="example-custom-modal-styling-title">
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        <h6 className="mb-0">Fetch via Client ID</h6>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Enter Client ID<span className="red-star">*</span></Form.Label>
                        <Form.Control 
                            type="text"
                            placeholder="Client Id"
                            value={this.state.clientId}
                            onChange={e => this.setState({ clientId: e.target.value, disabled: false })}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="mr-2" onClick={() => this.setState({ showModal: false })}> Close </Button>
                    <Button variant="primary" 
                        disabled={!this.state.clientId.length || this.state.loading} 
                        onClick={e => this.handleLogin('self')}
                    >Fetch</Button>
                </Modal.Footer>
            </Modal>

            </div>
        );
    }
}
